import { PopupMenu as PopupMenuUi } from 'shared/components/ui/popup-menu';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const PopupMenu = styled(PopupMenuUi)<{ $height?: number }>`
  width: 30.4rem;

  ${({ $height }) =>
    $height &&
    css`
      height: ${$height}px;
    `}
`;

export const ParentLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  max-width: 20rem;

  overflow: hidden;

  color: ${({ theme }) => theme.palette.text.secondary};
  text-overflow: ellipsis;
  white-space: nowrap;
`;
